import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { SponsoredListPaginatorInterface } from '../models/sponsored.list.paginator.interface';

@Injectable()
export class SponsorshipService {

  constructor(private apiService: ApiService) {}

  /**
   * Get sponsored list
   */
  getSponsoredList(page: number, items: number): Observable<SponsoredListPaginatorInterface> {
    return this.apiService.get('sponsored/list/' + page + '/' + items);
  }
}
